// extracted by mini-css-extract-plugin
export default {"hideOnMobile":"_c4a46f7a","subTextItalic":"_cac208f8"};